// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PriorAuthorizationStatusDetails } from './priorAuthorizationStatusDetails.js';
import type { PriorAuthorizationStatusInsuranceModel } from './priorAuthorizationStatusInsuranceModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationStatusResponse {
    'transactionCorrelationId': string;
    'transactionDateTime': Moment;
    'caseNumber'?: string;
    'statusDetails': PriorAuthorizationStatusDetails | null;
    'insuranceDetails'?: PriorAuthorizationStatusInsuranceModel | null;
    'portalUrl'?: string;
    'providerPinNumber'?: string;
    'providerNpi'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationStatusResponse>> = [
        {
            "name":     "transactionCorrelationId",
            "baseName": "transactionCorrelationId",
            "type":     "string"
        },
        {
            "name":     "transactionDateTime",
            "baseName": "transactionDateTime",
            "type":     "Date"
        },
        {
            "name":     "caseNumber",
            "baseName": "caseNumber",
            "type":     "string"
        },
        {
            "name":     "statusDetails",
            "baseName": "statusDetails",
            "type":     "PriorAuthorizationStatusDetails"
        },
        {
            "name":     "insuranceDetails",
            "baseName": "insuranceDetails",
            "type":     "PriorAuthorizationStatusInsuranceModel"
        },
        {
            "name":     "portalUrl",
            "baseName": "portalUrl",
            "type":     "string"
        },
        {
            "name":     "providerPinNumber",
            "baseName": "providerPinNumber",
            "type":     "string"
        },
        {
            "name":     "providerNpi",
            "baseName": "providerNpi",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationStatusResponse.attributeTypeMap;
    }
}
